import { Button, Checkbox, Modal, Stack, Text } from '@mantine/core';
import {
  DataProtectionGuidelines,
  ErrorModal,
  PageContainer,
  PageFooter,
  PageHeader,
  TermsAndConditions,
} from '../../../shared_components';
import { useTranslation } from 'react-i18next';
import { useKeycloakStore } from '../../../shared_stores';
import { useForm } from '@mantine/form';
import { useState } from 'react';
import { useDisclosure } from '@mantine/hooks';
import classes from '../../../app.module.css';
import { userInfo } from '@web/common';
import { z } from 'zod';
import { useUserDataStore } from '../../../shared_stores/userDataStore/userDataStore';

export const EditConsents = () => {
  const { t } = useTranslation(['common', 'legal', 'profile']);
  const kcStore = useKeycloakStore();
  const userDataStore = useUserDataStore();
  const [opened, { open, close }] = useDisclosure(false);
  const [showTermsAndConditions, setShowTermsAndConditions] = useState(false);
  const [showDataProtection, setShowDataProtection] = useState(false);
  const [gtcConsent, setGtcConsent] = useState(true);
  const [displayError, setDisplayError] = useState(false);
  const form = useForm<z.input<typeof userInfo>>({
    initialValues: userDataStore.userInfo,
  });

  const handleSubmit = async () => {
    if (!gtcConsent) {
      open();
    } else {
      try {
        await userDataStore.updateUserInfo(kcStore.token, form.getValues());
        window.history.back();
      } catch (error) {
        console.error(error);
        setDisplayError(true);
      }
    }
  };

  const handleAccountDeletion = async () => {
    try {
      await kcStore.deleteUser();
    } catch (error) {
      console.error(error);
      setDisplayError(true);
    } finally {
      close();
    }
  };

  return (
    <>
      {showTermsAndConditions && (
        <TermsAndConditions onClose={() => setShowTermsAndConditions(false)} />
      )}
      {showDataProtection && (
        <DataProtectionGuidelines
          onClose={() => setShowDataProtection(false)}
        />
      )}
      {!showTermsAndConditions && !showDataProtection && (
        <PageContainer>
          <ErrorModal
            opened={displayError}
            onClose={() => setDisplayError(false)}
          />
          <Modal
            classNames={{ content: classes.modalContentWhite }}
            opened={opened}
            onClose={close}
            title={t('profile:revoked_consents_warning_title')}
          >
            <Stack>
              <Text>{t('profile:revoked_consents_warning_message')}</Text>
              <Button
                onClick={() => void handleAccountDeletion()}
                style={{ backgroundColor: 'var(--mantine-color-otherRed-0)' }}
              >
                {t('delete_account')}
              </Button>
              <Button variant={'outline'} onClick={close}>
                {t('cancel')}
              </Button>
            </Stack>
          </Modal>
          <PageHeader
            title={t('profile:edit_consents_title')}
            message={t('profile:edit_consents_message')}
          />
          <form onSubmit={form.onSubmit(handleSubmit, console.log)}>
            <Stack>
              <Checkbox
                checked={gtcConsent}
                label={
                  <Text>
                    {t('legal:consent_end_user_agreement_1')}{' '}
                    <a
                      href={'/'}
                      onClick={(e) => {
                        e.preventDefault();
                        setShowTermsAndConditions(true);
                      }}
                    >
                      {t('legal:end_user_agreement')}
                    </a>{' '}
                    &{' '}
                    <a
                      href={'/'}
                      onClick={(e) => {
                        e.preventDefault();
                        setShowDataProtection(true);
                      }}
                    >
                      {t('legal:data_protection_guidelines')}
                    </a>{' '}
                    {t('legal:consent_end_user_agreement_2')}
                  </Text>
                }
                onChange={(event) => {
                  setGtcConsent(event.currentTarget.checked);
                }}
              />
              {/* TODO CBYN-186: VERSION 2 Feature - newsletter */}
              {/* <Checkbox
                defaultChecked={userDataStore.userInfo?.marketingConsent}
                label={t('checkbox_newsletter')}
                {...form.getInputProps('marketingConsent')}
              /> */}
            </Stack>

            <PageFooter
              leftOnClick={() => window.history.back()}
              submitButton
              buttonText={t('common:save_changes')}
            />
          </form>
        </PageContainer>
      )}
    </>
  );
};
